import React from 'react';
import Row from '@amzn/meridian/row';
import { isNullOrWhitespace } from '@amzn/dots-core-ui';
import { CoreAsyncSelect } from '../../../components/CoreAsyncSelect';
import { useClient } from '../../../api';

interface BuildVersionFiltersProps {
  projectName: string;
  filters: Map<string, string>;
  onFilterChange: (filter: string, value: string | undefined) => void;
}

export const BuildVersionFilters = ({
  projectName,
  filters,
  onFilterChange,
}: BuildVersionFiltersProps): JSX.Element => {
  const { projects } = useClient();

  const getFilterOptions = async (
    query: string,
    filterType?: string
  ): Promise<string[]> => {
    if (isNullOrWhitespace(query)) {
      return [];
    }

    console.log(
      `Getting filter options for project: ${projectName}, filter type: ${
        filterType || 'default'
      }`
    );

    const { content } = await projects.getProjectNames(query);
    return content;
  };

  return (
    <Row spacing="400" widths="grid-4" wrap="down">
      <CoreAsyncSelect
        value={filters.get('status')}
        onChange={(value) => onFilterChange('status', value as string)}
        label="Status"
        placeholder="Choose a status..."
        getItems={(query) => getFilterOptions(query, 'status')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('promotion')}
        onChange={(value) => onFilterChange('promotion', value as string)}
        label="Promotion"
        placeholder="Choose a promotion..."
        getItems={(query) => getFilterOptions(query, 'promotion')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('build type')}
        onChange={(value) => onFilterChange('build type', value as string)}
        label="Build Type"
        placeholder="Choose a build type..."
        getItems={(query) => getFilterOptions(query, 'build type')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('build version')}
        onChange={(value) => onFilterChange('build version', value as string)}
        label="Build Version"
        placeholder="Choose a build version..."
        getItems={(query) => getFilterOptions(query, 'build version')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('notes')}
        onChange={(value) => onFilterChange('notes', value as string)}
        label="Notes"
        placeholder="Filter by notes..."
        getItems={(query) => getFilterOptions(query, 'notes')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('milestone')}
        onChange={(value) => onFilterChange('milestone', value as string)}
        label="Milestone"
        placeholder="Choose a milestone..."
        getItems={(query) => getFilterOptions(query, 'milestone')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('start date')}
        onChange={(value) => onFilterChange('start date', value as string)}
        label="Start Date"
        placeholder="Filter by start date..."
        getItems={(query) => getFilterOptions(query, 'start date')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('end date')}
        onChange={(value) => onFilterChange('end date', value as string)}
        label="End Date"
        placeholder="Filter by end date..."
        getItems={(query) => getFilterOptions(query, 'end date')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
      <CoreAsyncSelect
        value={filters.get('revision')}
        onChange={(value) => onFilterChange('revision', value as string)}
        label="Revision"
        placeholder="Choose a revision..."
        getItems={(query) => getFilterOptions(query, 'revision')}
        getItemLabel={(item): string => item}
        getItemValue={(item): string => item}
      />
    </Row>
  );
};
